<div class="cm-block">
  <section class="contact-wholesaler-sec">
    <h1 class="cw-title" role="heading" aria-level="2" tabindex="0">Contact your wholesalers</h1>

    <!-- Skeleton loader while loading -->
    <ng-container *ngIf="isLoading; else wholesalerInfosTemplate">
      <app-skeleton-line></app-skeleton-line>
      <app-skeleton-line width="80%"></app-skeleton-line>
      <app-skeleton-line width="60%"></app-skeleton-line>
      <app-skeleton-line width="90%"></app-skeleton-line>
    </ng-container>

    <ng-template #wholesalerInfosTemplate>
      <ng-container *ngIf="!hasWholesalerInfo">
        <ul class="cw-items">
          <li class="cw-list">
            <p class="cw-subheading" tabindex="0">Please call 877.345.grow (4769), option 1</p>
          </li>
          <li class="cw-list def-phone">
            <div class="cw-subheading"></div>
          </li>
        </ul>
      </ng-container>

      <ng-container *ngIf="hasWholesalerInfo">
        <ul class="cw-items" *ngFor="let wholesaler of wholesalerInfo">
          <li class="cw-list name">
            <div class="cw-subheading">{{ wholesaler.firstName }} {{ wholesaler.lastName }}</div>
          </li>
          <li class="cw-list phone">
            <div class="cw-subheading">
              <a [href]="'tel:' + wholesaler.phoneNumber" class="phone-link">{{ wholesaler.phoneNumber }}</a>
            </div>
          </li>
          <li class="cw-list email">
            <div class="cw-subheading">
              <a [href]="'mailto:' + wholesaler.emailAddress" class="wholesaler-email">{{ wholesaler.emailAddress }}</a>
            </div>
          </li>
        </ul>
      </ng-container>
    </ng-template>
  </section>
  <br />
</div>
